import script from "./ContactUs2.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactUs2.vue?vue&type=script&lang=ts&setup=true"

import "./ContactUs2.vue?vue&type=style&index=0&id=fcac0278&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcac0278"]])

export default __exports__